import { TARIFF_COOKIE_NAME, EVENT_TARIFFS_COOKIE_CHANGED, EVENT_TARIFF_CARD_INITIALIZED } from '@parent-js';

jQuery(document).ready(function () {
    const formBlock = document.querySelector('.form-block');
    if (!formBlock) return;

    const wpcf7Form = jQuery(formBlock).find('.wpcf7-form');
    const tariffSelect = wpcf7Form.find('[name="form-tariff"]');
    const formWrapper = formBlock.querySelector('.form-block__wrapper');
    const tariffInfoBlock = formBlock.querySelector('[data-tariff-info]');

    loadTariffs();

    async function loadTariffs() {
        const tariffs = window.YarusTariffs?.instance;
        if (!tariffs || !tariffInfoBlock) {
            return;
        }

        formWrapper.classList.add('loading');

        try {
            const cards = await tariffs.loadCard('[data-tariff-info]', {
                template: 'selected-tariff-info'
            });

            if (cards?.length) {
                formWrapper.classList.add('has-tariff');
                tariffInfoBlock.style.display = 'flex';
            }
        } catch (e) {
            console.error(e);
        } finally {
            formWrapper.classList.remove('loading');
        }
    }

    document.addEventListener(EVENT_TARIFF_CARD_INITIALIZED, ({ detail }) => {
        tariffSelect.val(detail?.state?.data?.id || '');
    });

    document.addEventListener(EVENT_TARIFFS_COOKIE_CHANGED, () => loadTariffs());

    function clearTariffSelection() {
        jQuery.removeCookie(TARIFF_COOKIE_NAME, { path: '/' });
        formWrapper?.classList.remove('has-tariff');

        if (tariffInfoBlock) {
            tariffInfoBlock.innerHTML = '';
            tariffInfoBlock.style.display = 'none';
        }
    }

    function initPolicyCheckbox() {
        const submitButton = formBlock.querySelector('.button-submit');
        const policyCheckbox = formBlock.querySelector('.policy-checkbox');

        if (!submitButton || !policyCheckbox) return;

        submitButton.classList.add('disabled');

        policyCheckbox.addEventListener('change', function () {
            submitButton.classList.toggle('disabled', !this.checked);
        });
    }

    initPolicyCheckbox();

    document.addEventListener('wpcf7mailsent', function (event) {
        if (!event?.target || !(event.target instanceof HTMLElement)) return;
        if (!formBlock.contains(event.target)) return;
        clearTariffSelection();
    });
});
